import { IMAGES } from "./imagesImports";

export const section2Images = [
    {
        src: IMAGES.IMM_STAT_1,
        alt: "stat-1",
        text: 'We help individuals, attorneys, and immigration professionals meet USCIS translation requirements with confidence. Whether you are preparing your first immigration filing or working with a backlog of personal records, our translation service simplifies the process.'
    },
    {
        src: IMAGES.IMM_STAT_2,
        alt: "stat-2",
        text: 'Every USCIS-certified translation must include a certificate of translation that attests to the accuracy and completeness of the translation. eVerbary’s certified translation services include this certificate with each document translated.'
    }
];

export const section3Images = [
    {
        src: IMAGES.IMM_RED_LANG,
        alt: "birth_language",
        text: 'A full English translation of the original document'
    },
    {
        src: IMAGES.IMM_RED_PEN,
        alt: "birth_pen",
        text: 'A signed certificate of translation accuracy from a certified professional translator'
    },
    {
        src: IMAGES.IMM_RED_MEDAL,
        alt: "medal",
        text: 'Translation completed by a certified translator competent to translate the document'
    },
    {
        src: IMAGES.IMM_SHIELD_RED,
        alt: "medal",
        text: 'Assurance that the translation is complete and accurate'
    }
];

export const section5Images = [
    {
        src: IMAGES.IMM_ASSESSMENT_1,
        alt: "birth_assessment_1",
        heading: 'Upload the document',
        description: 'Submit your files securely online.',
        backgroundColor: '#F46350'
    },
    {
        src: IMAGES.IMM_ASSESSMENT_2,
        alt: "birth_assessment_2",
        heading: 'Review and quote',
        description: 'We assess the page count to provide pricing.',
        backgroundColor: '#7245ED'
    },
    {
        src: IMAGES.IMM_ASSESSMENT_3,
        alt: "birth_assessment_3",
        heading: 'Assign a certified professional translator',
        description: 'Your document is assigned to a translator trained in USCIS requirements.',
        backgroundColor: '#12ABBF'
    },
    {
        src: IMAGES.IMM_ASSESSMENT_4,
        alt: "birth_assessment_4",
        heading: 'Translate and certify',
        description: 'We translate documents and include the official certificate of translation.',
        backgroundColor: '#F46350'
    },
    {
        src: IMAGES.IMM_ASSESSMENT_5,
        alt: "birth_assessment_5",
        heading: 'Delivery',
        description: 'Documents are returned digitally with fast turnaround, and you may request hard copies if needed.',
        backgroundColor: '#7245ED'
    },
];

export const section6Images = [
    {
        src: IMAGES.IMM_SEC6_1,
        alt: "imm_sec6_1",
        text: 'Certified translations for USCIS with guaranteed acceptance'
    },
    {
        src: IMAGES.IMM_SEC6_2,
        alt: "imm_sec6_2",
        text: 'Certificate translation with full English translation and notarization upon request'
    },
    {
        src: IMAGES.IMM_SEC6_3,
        alt: "imm_sec6_3",
        text: 'Clear formatting and easy readability'
    },
    {
        src: IMAGES.IMM_SEC6_4,
        alt: "imm_sec6_4",
        text: 'Transparent translation pricing based on page count'
    }
]

export const section7Images = [
    {
        src: IMAGES.IMM_SEC7_1,
        alt: "imm_sec7_1",
        text: 'Certified English translation from expert translators'
    },
    {
        src: IMAGES.IMM_SEC7_2,
        alt: "imm_sec7_2",
        text: 'Fast and accurate service'
    },
    {
        src: IMAGES.IMM_SEC7_3,
        alt: "imm_sec7_3",
        text: 'USCIS acceptance guarantee'
    },
    {
        src: IMAGES.IMM_SEC7_4,
        alt: "imm_sec7_4",
        text: 'Clear pricing at $24.95 per page'
    },
    {
        src: IMAGES.IMM_SEC7_5,
        alt: "imm_sec7_5",
        text: 'Translation from a professional translator, not software'
    },
    {
        src: IMAGES.IMM_SEC7_6,
        alt: "imm_sec7_6",
        text: 'Experience with thousands of documents translated for USCIS'
    }
]

export const section8Images = [
    {
        src: IMAGES.IMM_SEC8_1,
        alt: "imm_sec8_1",
        text: 'USCIS certified translation'
    },
    {
        src: IMAGES.IMM_SEC8_1,
        alt: "imm_sec8_2",
        text: 'Immigration translation services'
    },
    {
        src: IMAGES.IMM_SEC8_1,
        alt: "imm_sec8_3",
        text: 'Translation certification'
    },
    {
        src: IMAGES.IMM_SEC8_1,
        alt: "imm_sec8_4",
        text: 'Professional services for all immigration documents'
    },
]

export const section10Images = [
    {
        src: IMAGES.IMM_SEC10_LEFTDIV,
        alt: 'section_10_orange',
        heading: 'Timing and Translation Turnaround',
        desc: 'We respect your time and deadlines. All 1–3 page documents are completed within 24 hours. Turnaround may vary depending on the complexity of the document and translator availability. <br/> We provide fast, professional translation for immigration use with flexibility for expedited orders.',
        background: '#F46350',
        width: '330',
        textWidth: '587px'
    },
    {
        src: IMAGES.IMM_SEC10_RIGHTDIV,
        alt: 'section_10_blue',
        heading: 'Translation Pricing and Costs',
        desc: 'Our pricing is simple. We charge $24.95 per page. Rates may adjust based on complexity and volume. <br/> Translation services cost less than legal fees for rejected documents. With eVerbary, you get certified translations that save time and avoid unnecessary USCIS delays.',
        background: '#5F2EE7',
        width: '280',
        textWidth: '551px'
    }
]


